module.exports = __webpack_public_path__ + "static/media/amity-ratings.91c51645.jpg";